import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface privateRouteProps {
    children: React.ReactElement
}

export const PrivateRoute = ({ children }: privateRouteProps) => {
    const { user } = useAuth();
    return (
        user ? children : <Navigate to="/auth/login" />
    );
}